import { helper as buildHelper } from '@ember/component/helper';
import { typeOf } from '@ember/utils';

/**
 * Accepts a key + object as params in the template and determines if the
 * key is the last key in the array produced by Object.keys(object).  Useful
 * for Ember's {{each-in}} iterator helper
 *
 * @param params
 * @returns {boolean}
 */
export function isLastKeyInObject(params/*, hash*/) {

  let key = params[0];
  let object = params[1];

  if (typeOf(object) !== 'object') {
    throw 'isLastKeyInObject Error: Passed in Object must be an [object]!';
  }

  let keys = Object.keys(object);

  return keys[keys.length - 1] === key;
}

export default buildHelper(isLastKeyInObject);
